/* AZ & CO search core: normaliser, say-it-your-way rewrite, intents. Tested offline with tools/azs-test.js. No DOM, no network. */
(function (root) {
  'use strict';
  var ARABIC = /[؀-ۿ]/;
  var state = null;

  function normalise(s) {
    s = String(s == null ? '' : s).toLowerCase();
    s = s
      .replace(/[ً-ٰٕـ]/g, '')
      .replace(/[أإآٱ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/ى/g, 'ي')
      .replace(/ؤ/g, 'و')
      .replace(/ئ/g, 'ي')
      .replace(/ک/g, 'ك')
      .replace(/ی/g, 'ي')
      .replace(/[٠-٩]/g, function (d) { return String(d.charCodeAt(0) - 0x0660); })
      .replace(/[۰-۹]/g, function (d) { return String(d.charCodeAt(0) - 0x06F0); });
    s = s.normalize('NFD').replace(/[̀-ͯ]/g, '').normalize('NFC');
    s = s.replace(/&/g, ' and ');
    s = s.replace(/[^\p{L}\p{N}\s]/gu, ' ');
    return s.replace(/\s+/g, ' ').trim();
  }

  function load(words) {
    var st = { strip: {}, map: {}, intents: [], strength: [], maxWords: 1 };
    (words.strip || []).forEach(function (w) { st.strip[normalise(w)] = 1; });
    function add(key, entry) {
      var k = normalise(key);
      if (!k) return;
      if (!(k in st.map)) st.map[k] = entry;
      var n = k.split(' ').length;
      if (n > st.maxWords) st.maxWords = n;
    }
    function addGroup(list, kind) {
      (list || []).forEach(function (e) {
        var to = normalise(e.to), show = e.show || null, h = e.h || null, ar = e.ar || null;
        add(e.to, { kind: kind, to: to, show: show, h: h, ar: ar, self: true, matched: e.to });
        (e.say || []).forEach(function (k) {
          add(k, { kind: kind, to: to, show: show, h: h, ar: ar, self: false, matched: k });
        });
      });
    }
    addGroup(words.houses, 'house');
    addGroup(words.bottles, 'bottle');
    addGroup(words.notes, 'note');
    (words.intents || []).forEach(function (it) {
      st.intents.push({
        id: it.id, mode: it.mode,
        say: (it.say || []).map(normalise).sort(function (a, b) { return b.length - a.length; }),
        re: it.pattern ? new RegExp(it.pattern) : null
      });
    });
    st.strength = (words.strength || []).map(normalise).sort(function (a, b) { return b.length - a.length; });
    state = st;
    return st;
  }

  function hasPhrase(text, phrase) {
    var padded = ' ' + text + ' ';
    var i = padded.indexOf(' ' + phrase + ' ');
    if (i < 0) return null;
    return (padded.slice(0, i) + ' ' + padded.slice(i + phrase.length + 2)).replace(/\s+/g, ' ').trim();
  }

  function stripAndRewrite(text) {
    var st = state;
    var toks = text ? text.split(' ') : [];
    var kept = toks.filter(function (t) { return !st.strip[t]; });
    if (!kept.length) kept = toks;
    var out = [], fired = [], i = 0;
    while (i < kept.length) {
      var hit = null, n;
      for (n = Math.min(st.maxWords, kept.length - i); n >= 1; n--) {
        var e = st.map[kept.slice(i, i + n).join(' ')];
        if (e) { hit = e; break; }
      }
      if (hit) {
        out.push(hit.to);
        if (!hit.self) fired.push({ kind: hit.kind, to: hit.to, show: hit.show, h: hit.h, ar: hit.ar, matched: hit.matched });
        else if (hit.kind === 'house') fired.push({ kind: 'house', to: hit.to, show: hit.show, h: hit.h, ar: hit.ar, matched: hit.matched, self: true });
        i += n;
      } else { out.push(kept[i]); i++; }
    }
    out = out.join(' ').split(' ').filter(function (t, k, a) { return k === 0 || t !== a[k - 1]; });
    return { q: out.join(' '), fired: fired };
  }

  function rewrite(text) {
    if (!state) throw new Error('AZS: word list not loaded');
    var st = state;
    var norm = normalise(text);
    var res = { typed: String(text == null ? '' : text), norm: norm, q: norm, changed: false, fired: [], intents: [], strength: false, arabic: ARABIC.test(String(text || '')) };
    if (!norm) return res;
    var rest = norm;
    st.intents.forEach(function (it) {
      if (it.mode === 'pattern' && it.re) {
        var m = it.re.exec(norm);
        if (m) { res.intents.push({ id: it.id, value: m[1] || null }); rest = ''; }
        return;
      }
      for (var j = 0; j < it.say.length; j++) {
        var p = it.say[j];
        if (it.mode === 'whole') {
          if (norm === p) { res.intents.push({ id: it.id, phrase: p }); rest = ''; return; }
        } else {
          var left = hasPhrase(norm, p);
          if (left !== null) { res.intents.push({ id: it.id, phrase: p }); rest = hasPhrase(rest, p) !== null ? hasPhrase(rest, p) : rest; return; }
        }
      }
    });
    for (var s = 0; s < st.strength.length; s++) {
      var left2 = hasPhrase(rest, st.strength[s]);
      if (left2 !== null) { res.strength = true; rest = left2; break; }
    }
    var base = (res.intents.length || res.strength) ? rest : norm;
    if (!base && !(res.intents.length || res.strength)) base = norm;
    var r = stripAndRewrite(base);
    res.q = r.q;
    res.fired = r.fired;
    res.changed = r.fired.some(function (f) { return !f.self; }) && r.q !== norm;
    return res;
  }

  function houseLabel(fired, typedHasArabic) {
    if (!fired || !fired.show) return fired && fired.to;
    if (typedHasArabic && fired.ar) return fired.show + ' · ' + (fired.matched && ARABIC.test(fired.matched) ? fired.matched : fired.ar);
    return fired.show;
  }

  var api = { normalise: normalise, load: load, rewrite: rewrite, houseLabel: houseLabel };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.AZS = api;
})(typeof window !== 'undefined' ? window : this);
